<template>
    <footer class="bg-black text-white py-12 print:hidden">

        <div class="max-w-screen-lg mx-auto flex items-center justify-center mb-6">
            <div class="flex items-center gap-6">
                <template v-if="site.navigation?.footer?.length" v-for="page in site.navigation?.footer">
                    <a class="font-semibold hover:text-[var(--primary-400)]"
                       :href="page.url"
                       v-html="(page.navigation_label || page.title)"
                    />
                </template>
            </div>
        </div>

        <p class="text-center text-sm text-[var(--secondary-400)]">
            &copy; {{ site.name }} &middot; All Rights Reserved
        </p>

    </footer>
</template>

<script>
export default {
    name: 'SiteFooter',
    data() {
        return {
            site: window.app?.site || {},
        };
    },
}
</script>
